export default function TableFieldsSection() {
  return (
    <div className="ad-card">

      <div className="ad-card-header">
        <div className="ad-card-title">Table Fields</div>

        <div>
          <button className="ad-btn ad-btn-outline">
            Select All
          </button>

          <button className="ad-btn ad-btn-outline" style={{ marginLeft: "10px" }}>
            Deselect All
          </button>
        </div>
      </div>

      <div className="ad-empty">
        <div className="ad-empty-title">
          Select SQL tables to load fields
        </div>
      </div>

    </div>
  );
}